import React, { useEffect, useState } from "react";

// Assets
import "~/assets/sass/pages/invest/IrModal/common.scss";

import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import { useGlobalStore } from "~/store";
import CommentaryModal from "./modalForJudge/CommentaryModal";
import IrDetailModal from "./modalForJudge/IrDetailModal";
import ResultAnnounceModal from "./modalForJudge/ResultAnnounceModal";
import AlertForJudgeAdmin from "./alertForJudgeAdmin/AlertForJudgeAdmin";
import { Case, If } from "~/common/components/If";
import BeforeEvaluation from "./cardForJudge/BeforeEvaluation";
import AfterEvalUser from "./cardForJudge/AfterEvalUser";
import AfterEvalAdmin from "./cardForJudge/AfterEvalAdmin";
import { useTranslation } from "react-i18next";

const Judge = ({ param, detailRequest }) => {
	const { t } = useTranslation();
	const [commentaryModal, setCommentaryModal] = useState(false);
	const [IrModal, setIrModal] = useState(false);
	const [userForCommentary, setUserForCommentary] = useState();

	const [resultAnnounceModal, setResultAnnounceModal] = useState(false);
	const [noResultAnnounceAlert, setNoResultAnnounceAlert] = useState(false);

	const [evalStatus, setEvalStatus] = useState(
		t("pages.investment.InvestEvalPage.detail.Step.judge-bak.evalStatus01")
	);
	const [completeRate, setCompleteRate] = useState(0);
	const [investInfo, setInvestInfo] = useState();
	const [irInfo, setIrInfo] = useState();
	const irDetailRequest = useRequest("get", "/vc/invest/ir/detail");
	const [
		{
			user: { info, company },
		},
	] = useGlobalStore();
	// 심사하기 및 심사 완료 상태 구현
	useEffect(() => {
		// 현재 유저
		const loginedUser = info.idx;
		const loginedUserRole = info.role;

		// 현재 로그인 유저의 scoreList 준비
		const scoreList = investInfo?.Judge.find((d) => d.userIdx === loginedUser);
		const scoreYN = scoreList?.Score.length;

		// 심사 완료 X - scoreList = [] && All user Available
		if (scoreYN === 0) {
			setEvalStatus(t("pages.investment.InvestEvalPage.detail.Step.judge-bak.evalStatus01"));
		} else if (scoreYN !== 0 && loginedUserRole === "user") {
			// 심사 완료 O with user - scoreList 에 값이 있어야 하고 user 만 가능
			setEvalStatus(t("pages.investment.InvestEvalPage.detail.Step.judge-bak.evalStatus02"));
		} else if (scoreYN !== 0 && loginedUserRole === "admin") {
			// 심사 완료 O with admin - scoreList 에 값이 있어야 하고 admin 만 가능
			setEvalStatus(t("pages.investment.InvestEvalPage.detail.Step.judge-bak.evalStatus03"));
		}
	}, [info, investInfo]);
	useEffect(() => {
		irDetailRequest.singleCall(param.idx, "path");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	useEffect(() => {
		switch (irDetailRequest.state) {
			case API_STATE.done:
				setInvestInfo(irDetailRequest.response?.data?.Invest);
				setIrInfo(irDetailRequest.response?.data?.IrInfo);
				break;
			case API_STATE.error:
				console.log("error >> ", irDetailRequest.error);
				break;
			default:
				break;
		}
	}, [irDetailRequest.state, irDetailRequest.response, irDetailRequest.error]);

	useEffect(() => {
		const totalJudge = investInfo?.Judge;
		const completedJudge = totalJudge?.filter((d) => d.Score.length !== 0);
		const completedRate = (completedJudge?.length / totalJudge?.length) * 100;
		setCompleteRate(parseFloat(isNaN(completedRate) ? 0 : completedRate));
		// setCompleteRate(parseFloat(0).toFixed(2));
	}, [investInfo]);

	const showCommentary = (yn, index) => {
		setUserForCommentary(index);
		setCommentaryModal(yn);
	};

	return (
		<>
			<If condition={evalStatus} {...{ completeRate, info }}>
				<Case
					condition={t(
						"pages.investment.InvestEvalPage.detail.Step.judge-bak.evalStatus01"
					)}
				>
					{/*심사하기*/}
					<BeforeEvaluation {...{ setIrModal, investInfo, showCommentary }} />
				</Case>
				<Case
					condition={t(
						"pages.investment.InvestEvalPage.detail.Step.judge-bak.evalStatus02"
					)}
				>
					{/*심사진행 완료 - 사용자 - user info 에 role 이 user 면 이화면*/}
					<AfterEvalUser
						{...{ setIrModal, setCommentaryModal, investInfo, showCommentary }}
					/>
				</Case>
				<Case
					condition={t(
						"pages.investment.InvestEvalPage.detail.Step.judge-bak.evalStatus03"
					)}
				>
					{/*심사진행 완료 - 관리자 - user info 에 role 이 admin 이면 이 화면!! */}
					<AfterEvalAdmin
						{...{
							setIrModal,
							setResultAnnounceModal,
							setNoResultAnnounceAlert,
							setCommentaryModal,
							investInfo,
							showCommentary,
						}}
					/>
				</Case>
			</If>

			{/*심사하기 모달 - IrModal*/}
			<IrDetailModal
				{...{
					IrModal,
					setIrModal,
					irInfo,
					investInfo,
					param,
					info,
					company,
					irDetailRequest,
					evalStatus,
				}}
			/>

			{/*심사평 모달 - CommentaryModal*/}
			<CommentaryModal
				{...{ commentaryModal, setCommentaryModal, investInfo, info, userForCommentary }}
			/>

			{/*결과통보 모달 - ResultAnnounceModal*/}
			<ResultAnnounceModal
				{...{
					resultAnnounceModal,
					setResultAnnounceModal,
					info,
					irInfo,
					company,
					param,
					detailRequest,
					investInfo,
				}}
			/>

			<AlertForJudgeAdmin
				{...{
					noResultAnnounceAlert,
					setNoResultAnnounceAlert,
				}}
			/>
		</>
	);
};

export default Judge;
